import { FormValues } from '../../../features/dash/views/finance/Invoices/AddEditInvoice';
import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { Invoice } from '../../../types/finance.types';
import { sfcApi } from '../../api';

export interface InvoiceEmails {
  id: number;
  contact_ids: string[];
}

export const invoiceApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllInvoices: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: `invoices${params?.scope ? `?scope=${params.scope}` : ''}`,
        method: 'POST',
        body: params?.data
      }),
      providesTags: ['Invoice']
    }),
    getInvoice: builder.query<{ invoice: Invoice }, number>({
      query: (id) => `invoices/${id}`,
      providesTags: (result, error, id) => [{ type: 'Invoice', id }]
    }),
    updateInvoice: builder.mutation<{ invoice: Invoice }, FormValues>({
      query: (data) => {
        const { id } = data;
        delete data.id;
        return {
          url: `invoices/update/${id}`,
          method: 'PUT',
          body: data
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: 'Invoice', id: result?.invoice?.id },
        'Invoice',
        'Course'
      ]
    }),
    deleteInvoice: builder.mutation<{ invoice: Invoice }, number>({
      query: (id) => ({
        url: `invoices/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Invoice', id }, 'Invoice', 'Course']
    }),
    sendInvoice: builder.mutation<{ InvoiceEmails: InvoiceEmails }, InvoiceEmails>({
      query: (data) => {
        const { id } = data;
        // delete data.id;
        return {
          url: `invoices/issue-invoice/${id}`,
          method: 'POST',
          body: { contact_ids: data?.contact_ids }
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: 'Invoice', id: result?.InvoiceEmails?.id },
        'Invoice'
      ]
    }),
    warnInvoice: builder.mutation<{ invoice: Invoice }, InvoiceEmails>({
      query: (data) => {
        const { id } = data;
        // delete data.id;
        return {
          url: `invoices/warn-invoice/${id}`,
          method: 'POST',
          body: { contact_ids: data?.contact_ids }
        };
      },
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const result = await queryFulfilled;
          console.log('warnInvoice response:', result);
        } catch (error) {
          console.error('warnInvoice error:', error);
        }
      },
      invalidatesTags: (result, error, { id }) => [
        { type: 'Invoice', id: result?.invoice?.id },
        'Invoice'
      ]
    })
  })
});

export const {
  useGetAllInvoicesQuery,
  useGetInvoiceQuery,
  useUpdateInvoiceMutation,
  useDeleteInvoiceMutation,
  useSendInvoiceMutation,
  useWarnInvoiceMutation
} = invoiceApi;
